<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">Nabaco Academy: A Bridge to Knowledge and Success</h2>
            <div class="row mt-5 mx-auto">
                <div class="col-md-9">
                    <h5 class="mt-3">
                        Nabaco Academy is designed to provide you with the tools and knowledge needed for a deeper understanding of the financial world and advanced technologies. This section of the website serves as a comprehensive learning center, offering high-quality resources, courses, and articles in three key areas: financial literacy, blockchain, and artificial intelligence.
                    </h5>
                    <h5 class="mt-4">Nabaco Academy Goals</h5>
                    <h5 class="mt-3">
                        <strong>Increasing General Knowledge:</strong>  We believe that knowledge is power. Nabaco Academy’s goal is to teach complex concepts in a simple and understandable way.
                        <br>
                        <br>
                        <strong>Empowering Traders and Investors:</strong>  By providing practical and actionable information, we help you make more informed decisions.
                        <br>
                        <br>
                        <strong>Connecting Knowledge to Action:</strong>  Learning concepts alone is not enough; we help you apply what you’ve learned in real life and your financial trading.
                    </h5>
                </div>
                <div class="col-md-3">
                    <img src="../../../assets/logo.png" class="d-md-block d-none" style="width: 215px;" alt="">
                    <img src="../../../assets/logo.png" class="d-md-none d-block mx-auto" style="width: 100px;" alt="">
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-12 row">
                    <div class="col-md-6">
                        <img src="../../../../public/img/HosseinMalekinezhad.png" width="100%" alt="">
                    </div>
                    <div class="col-md-6 my-auto text-start">
                        <h3>Dr. Hossein Malekinejad</h3>
                        <h5>Chairman of the Board</h5>
                        <h5>Former Head of Technology at Banking Technologies</h5>
                        <h5>PhD in Artificial Intelligence and Machine Learning</h5>
                        <h5>Implemented Predictive Systems in the Financial Industry</h5>
                    </div>
                </div>
                <div class="col-12 row">
                    <div class="col-md-6 my-auto text-start">
                        <h3>Hossein Moazen</h3>
                        <h5>CEO</h5>
                        <h5>Master’s Degree in Management – Strategy</h5>
                        <h5>Experience in Implementing Intelligent Systems in Oil, Gas, and Petrochemical Industries</h5>
                        <h5>Consulting and Implementing AI- and IoT-Based Systems</h5>
                        <h5>Launching Startups in Iran and North America</h5>
                    </div>
                    <div class="col-md-6">
                        <img src="../../../../public/img/HoseinMoazen.png" width="100%" alt="">
                    </div>
                </div>
                <!-- <div class="col-12 row">
                    <div class="col-md-6">
                        <img src="../../../../public/img/miladTarverdi.png" width="100%" alt="">
                    </div>
                    <div class="col-md-6 my-auto text-start">
                        <h3>Dr. Milad Tarvardi</h3>
                        <h5>Co-founder and CMO</h5>
                        <h5>PhD in Business Management – Digital Transformation</h5>
                        <h5>Instructor of MBA and Business Courses at Shahid Beheshti University</h5>
                        <h5>Instructor of Practical and Skill-Based MBA Courses at Azad University</h5>
                        <h5>Consultant and Implementer of Digitalization Projects for Over 20 Businesses</h5>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style scoped>
    *{
        direction: ltr;
    }
</style>